var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-2"},[_c('ve-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }